
import { MarketingDiscountBatchStatusBadge } from 'domains/marketing-discount-batch'
import { STATUS } from 'domains/marketing-discount-batch/constants'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import TimeUtil from 'utils/time-util'

const propTypes = {
  discountBatchItem : PropTypes.object,
  handleClick       : PropTypes.func
}

const defaultProps = {
  discountBatchItem : {},
  handleClick       : () => {}
}

const MarketingDiscountBatchItemTableRow = ({
  discountBatchItem,
  handleClick
}) => {
  const discountBatch = discountBatchItem.discount_batch
  const product       = discountBatchItem.product

  const currentSellingPrice   = PriceUtil.format(product.selling_price)
  const expectedTlRevenue     = PriceUtil.format(product.revenue_tl)
  const expectedSellerRevenue = PriceUtil.format(product.revenue_seller)
  const newSellingPrice       = PriceUtil.format(discountBatchItem.new_selling_price)

  const warningCell = product.revenue_tl > 0 ? '' : 'table-danger'

  const start_date   = TimeUtil.format(discountBatch.start_batch_job_at, 'DD MMM YYYY HH:mm:ss')
  const expired_date = TimeUtil.format(discountBatch.expire_batch_job_at, 'DD MMM YYYY HH:mm:ss')

  const priceBeforeDiscount = PriceUtil.format(discountBatchItem.price_before_discount)
  const buttonText          = (discountBatchItem.status == STATUS.SCHEDULED ? 'Cancel' : 'Revert')
  const buttonColor         = (discountBatchItem.status == STATUS.SCHEDULED ? 'info' : 'danger')
  const buttonDisable       = [ STATUS.LIVE, STATUS.SCHEDULED ].includes(discountBatchItem.status) ? false : true

  return (
    <tr>
      <td>{ discountBatchItem.sku }</td>
      <td>{ currentSellingPrice }</td>
      <td className={ warningCell }>
        { expectedTlRevenue }
      </td>
      <td >{ expectedSellerRevenue }</td>
      <td>{ newSellingPrice }</td>
      <td>{ priceBeforeDiscount }</td>
      <td><MarketingDiscountBatchStatusBadge status={ discountBatchItem.status }/></td>
      <td>{ discountBatch.code }</td>
      <td>{ start_date }</td>
      <td>{ expired_date }</td>
      <td className="d-flex flex-column bd-highlight mb-3">
        <Button
          size='sm'
          color={ buttonColor }
          className= 'align-self-center'
          onClick={ () => handleClick(discountBatchItem.id) }
          disabled={ buttonDisable }
        >
          { buttonText }
        </Button>
      </td>
    </tr>
  )
}

MarketingDiscountBatchItemTableRow.propTypes    = propTypes
MarketingDiscountBatchItemTableRow.defaultProps = defaultProps

export default MarketingDiscountBatchItemTableRow